import { z } from 'zod';

export const CreateOwnerTenantInputSchema = z.object({
  name: z.string().min(1).max(200),
  slug: z
    .string()
    .min(2)
    .max(80)
    .regex(/^[a-z0-9-]+$/),
  ownerEmail: z.string().email(),
  ownerFirstName: z.string().max(100).optional(),
  ownerLastName: z.string().max(100).optional(),
  defaultCurrency: z.string().length(3).toUpperCase().default('CZK'),
  revenueSharePct: z.number().min(0).max(100).default(8),
  taxId: z.string().max(64).nullable().optional(),
});

export const UpdateOwnerTenantInputSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  slug: z
    .string()
    .min(2)
    .max(80)
    .regex(/^[a-z0-9-]+$/)
    .optional(),
  isActive: z.boolean().optional(),
  defaultCurrency: z.string().length(3).toUpperCase().optional(),
  revenueSharePct: z.number().min(0).max(100).optional(),
  taxId: z.string().max(64).nullable().optional(),
});

export const UpdateTenantSettingsInputSchema = z.object({
  defaultCurrency: z.string().length(3).toUpperCase().optional(),
  revenueSharePct: z.number().min(0).max(100).optional(),
  taxId: z.string().max(64).nullable().optional(),
  bookingNotificationChannel: z.enum(['EMAIL', 'SMS', 'BOTH']).optional(),
  bookingReminderLeadTimeMinutes: z.number().int().min(5).max(1440).optional(),
  bookingDayBeforeReminderEnabled: z.boolean().optional(),
});

export type CreateOwnerTenantInput = z.infer<typeof CreateOwnerTenantInputSchema>;
export type UpdateOwnerTenantInput = z.infer<typeof UpdateOwnerTenantInputSchema>;
export type UpdateTenantSettingsInput = z.infer<typeof UpdateTenantSettingsInputSchema>;
